import React, { forwardRef } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> {
  label: string;
  error?: string;
  as?: 'input' | 'textarea' | 'select';
  options?: {
    value: string;
    label: string;
  }[];
}
export const Input = forwardRef<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement, InputProps>(({
  label,
  error,
  as = 'input',
  options,
  className = '',
  ...props
}, ref) => {
  const baseInputStyles = `
      w-full bg-engage-gray2 border border-engage-gray3 rounded-sm px-4 py-3 text-engage-white 
      placeholder-engage-gray4 focus:outline-none focus:border-engage-yellow focus:ring-1 focus:ring-engage-yellow
      transition-colors duration-200
      ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}
    `;
  return <div className={`flex flex-col space-y-2 ${className}`} data-id="element-155" data-mp="2kxgn7esa9tt1">
      <label className="text-sm font-medium text-engage-gray5" data-id="element-156" data-mp="2oz25xgri12b5">{label}</label>

      {as === 'textarea' ? <textarea ref={ref as any} className={`${baseInputStyles} min-h-[120px] resize-y`} {...props as React.TextareaHTMLAttributes<HTMLTextAreaElement>} data-id="element-157" data-mp="2m2bs74g9un7c" /> : as === 'select' ? <select ref={ref as any} className={`${baseInputStyles} appearance-none`} {...props as React.SelectHTMLAttributes<HTMLSelectElement>} data-id="element-158" data-mp="2h0w9hj1kgss4">
          <option value="" disabled data-id="element-159" data-mp="280zdsxgretnk">
            Select an option
          </option>
          {options?.map(opt => <option key={opt.value} value={opt.value} className="bg-engage-gray2 text-engage-white" data-id="element-160" data-mp="233zh3d5sv394">
              {opt.label}
            </option>)}
        </select> : <input ref={ref as any} className={baseInputStyles} {...props as React.InputHTMLAttributes<HTMLInputElement>} data-id="element-161" data-mp="1td4mnliegxcl" />}

      {error && <span className="text-sm text-red-500 mt-1" data-id="element-162" data-mp="1oetcf9o70ktu">{error}</span>}
    </div>;
});
Input.displayName = 'Input';